import axiosIns from '@/libs/axios';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getReportEmailSettings() {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('getReportEmailSettings')
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    saveReportEmailSettings(ctx, payload) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('saveReportEmailSettings', payload)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    runReportEmailNow(ctx, payload) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('runReportEmailNow', payload)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
